import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { PaymentShareWhitelistItemsCollection } from './payment-share-whitelist-items.types';

export function paymentShareWhitelistItemsBackend(): Backend<PaymentShareWhitelistItemsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'users/0.1/payment_sharing/whitelist',
      isGaf: false,
      params: {},
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
